import PageViewer from "@/components/PageViewer";
import DSRC from "./DSRC";
import PERMISSIONS from "@/common/permissions-lib";
import store from "@/store";
import FEATURES from "@/common/feature-lib";

const rsuProps = route => {
	return {
		rsuIdentifier: route.params.rsuIdentifier,
		deviceIdentifier: route.params.rsuIdentifier,
		deviceType: "rsu"
	};
};

export default {
	path: "RSU",
	component: PageViewer,
	props: { pageTransition: "none" },
	meta: {
		authorizedRoles: [PERMISSIONS.RSU_VIEW]
	},
	children: [
		{
			path: "/",
			name: "DeviceManager.RSU",
			props: { pageTransition: "none" },
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.RSU" */ "@/views/DeviceManager/RSU/Index"
				)
		},
		{
			path: ":rsuIdentifier",
			props: rsuProps,
			meta: {
				breadcrumb() {
					const id = this.$route.params.rsuIdentifier;
					const device = this.$store.getters["rsu/byIdentifier"](id);
					return device ? device.locationDescription : id;
				}
			},
			component: PageViewer,
			children: [
				{
					path: "/",
					props: rsuProps,
					name: "DeviceManager.RSU.byIdentifier",
					component: () =>
						import(
							/* webpackChunkName: "DeviceManager.RSU.ByIdentifier" */ "@/views/DeviceManager/RSU/ByIdentifier"
						)
				},
				DSRC
			]
		},
		{
			path: "Config/:rsuIdentifier",
			component: PageViewer,
			props: rsuProps,
			beforeEnter: (to, from, next) => {
				if (
					!store.getters.currentUserHasFeature(FEATURES.RSU_NTCIP1218_CONFIG)
				) {
					next({
						name: "Unauthorized"
					});
				}
				next();
			},
			meta: {
				breadcrumb: "RSU Configuration",
				authorizedRoles: [PERMISSIONS.SCR_RSU_EDIT]
			},
			children: [
				{
					path: "/",
					name: "DeviceManager.RSU.CONFIG",
					props: route => {
						return {
							...rsuProps(route),
							pageTransition: "none"
						};
					},
					component: () => import("@/views/DeviceManager/RSU/CONFIG/RSUConfig")
				}
			]
		}
	]
};
